<template>
  <div>
  <div v-if="$auth.policies['view-period-list']">
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="route.meta.title"
          :link="[{ text: 'Tài chính', href: '#' }, { text: route.meta.title }]"
        />
      </div>
    </div>
    <v-card outlined class="pa-9 pr-3 mx-4 mb-6 elevation-0">
      <filterPeriod />
    </v-card>
    <v-card outlined class="mx-4 elevation-0 mb-16">
      <ListPeriod ref="tuitionFeeGroupTable" />
    </v-card>
    <group-dialog action="create" ref="groupDialog" />
  </div>
  <div v-else>
      <Page403 />
    </div>
</div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import filterPeriod from '@/modules/tuitionFee/tuitionFeePeriod/filterPeriod'
import ListPeriod from '@/modules/tuitionFee/tuitionFeePeriod/ListPeriod'
import GroupDialog from '@/modules/tuitionFee/group/GroupDialog'
import { mapActions } from 'vuex'
import Page403 from '@/views/Page403.vue'

export default {
  components: {
    Breadcrumbs,
    filterPeriod,
    ListPeriod,
    GroupDialog,
    Page403
  },
  computed: {
    route() {
      return this.$route
    },
  },
  methods: {
    ...mapActions('tuitionFeePeriod', ['fetchPeriods']),
  },
  async created() {
    await this.fetchPeriods()
  },
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
